import React from "react";
import { useNavigate } from "react-router-dom";

import { IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

const BackToMapButton = ({ disabled = false }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        navigate("/map");
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);

  return (
    <IconButton
      className={`btn btn-back btn-sm ${disabled ? "disable" : ""}`}
      variant="contained"
      onClick={() => navigate("/map")}
      aria-label="Back to map (esc)"
      disabled={disabled}
    >
      <ArrowBack size={20} />
      <span>Back to map (esc)</span>
    </IconButton>
  );
};
export default BackToMapButton;
